import BaseService from "../base";
class ShareTaskService extends BaseService {
  checkEdit = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("checkEdit", para, success, error);
  };

  // 1: no process 2: have process, no active 3: have process, have active 4: all active
  getSharingProcessStatus = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getShareProcessStatus", para, success, error);
  };

  getActiveShareTaskList = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getProcedureTaskList", para, success, error);
  };

  getMainTaskInfo = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getTaskRowList", para, success, error);
  };

  getAccountDDL = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getAccountDDL", para, success, error);
  };

  getTaskTreePathDDL = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getTaskTreePathDdl", para, success, error);
  };

  getRowData = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("getTaskRowInfo", para, success, error);
  };

  checkSubmit = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("checkSubmit", para, success, error);
  };

  submitForApproval = (para: any, success: any, error: any) => {
    // @ts-ignore
    this.sendRequest("shareTaskSubmitForApproval", para, success, error);
  };
}

const shareTaskService = new ShareTaskService();

export default shareTaskService;
